module.exports = __webpack_public_path__ + "static/media/tiangle_chillful.88308011.png";